import { lazy } from "react";
import type { RouteObject } from "react-router-dom";

const TermsOfUse = lazy(() => import("./app/views/termsOfUse"));
const LegalNotice = lazy(() => import("./app/views/legalNotice"));
const PrivacyPolicy = lazy(() => import("./app/views/privacyPolicy"));
const ErrorPage = lazy(() => import("@root/error"));

export const staticsRoutes: RouteObject[] = [
  {
    path: "/terms-of-use",
    element: <TermsOfUse />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/legal-notice",
    element: <LegalNotice />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
    errorElement: <ErrorPage />,
  },
];
